export default "assets/print-76969d88.svg";